module.exports = __webpack_public_path__ + "static/apple-icon-180x180-9a2a3b4e1178111a49580d95061a6ac5.png";